import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      groups_list: {
        group_settings: {
          header: 'HEADER_SETTINGS',
          current_owner: 'CURRENT_OWNER',
          choose_owner: 'CHOOSE_OWNER',
          choose_participants: 'CHOOSE_PARTICIPANTS',
          create_btn: 'CREATE_BTN',
          back: 'BACK',
          toasts: {
            group_has_been_created: 'GROUP_CREATED',
          },
        },
      },
    },
  }));
}
